// Open Locations, on a company with the map turned on. View All Locations alone
// opens nothing, so the backend never names the page for it.
export function canOpenLocations(
  featureGlobalMap: boolean | undefined,
  pages: readonly string[] | undefined
): boolean {
  return featureGlobalMap === true && pages?.includes("locations") === true
}
